import { periodFormat } from 'utils/common';
import { featuresFormater } from 'utils/featuresFormater';

export const createSaveList = location => {
  const query = new URLSearchParams(location.search);

  // Safe JSON parsing with fallback for fromTo
  let fromTo = { arrFrom: '', arrTo: '' };
  try {
    const fromToParam = query.get('fromTo');
    if (fromToParam !== 'null') {
      fromTo = JSON.parse(fromToParam);
    }
  } catch (error) {
    console.warn('Failed to parse fromTo parameter:', error);
    fromTo = { arrFrom: '', arrTo: '' };
  }

  const loadList = {
    fromTo,
    name: query.get('name') + '' !== 'null' ? query.get('name') : '',
    size:
      query.get('size') + '' !== '' ? query.get('size')?.split(',') || [] : [],
    pricing:
      query.get('pricing') + '' !== ''
        ? query.get('pricing')?.split(',') || []
        : [],
    cycle:
      query.get('cycle') + '' !== ''
        ? query.get('cycle')?.split(',') || []
        : [],
    date:
      query.get('start') + '' !== 'null'
        ? {
            startDate: query.get('start'),
            endDate: query.get('end')
          }
        : { startDate: null, endDate: null },
    country:
      query.get('country') + '' !== ''
        ? query.get('country')?.split(',') || []
        : [],
    industry:
      query.get('industry') + '' !== ''
        ? query.get('industry')?.split(',') || []
        : [],
    accountManager:
      query.get('accountManager') + '' !== ''
        ? query.get('accountManager')?.split(',') || []
        : [],
    customerSuccessEngineer:
      query.get('customerSuccessEngineer') + '' !== ''
        ? query.get('customerSuccessEngineer')?.split(',') || []
        : [],
    fa: query.get('fa') + '' !== '' ? query.get('fa')?.split(',') || [] : [],
    direction:
      query.get('direction') + '' !== 'null'
        ? Number(query.get('direction'))
        : -1,
    page: query.get('page') + '' !== 'null' ? Number(query.get('page')) : 1,
    limit: query.get('limit') + '' !== 'null' ? Number(query.get('limit')) : 10,
    fieldName:
      query.get('fieldName') + '' !== 'null' ? query.get('fieldName') : 'arr',
    orAnd: query.get('orAnd') + '' !== 'null' ? query.get('orAnd') : 'OR'
  };
  return loadList;
};

export const featuresReq = (
  date,
  filterInput,
  size,
  fa,
  billingCycle,
  plan,
  country,
  industry,
  accountManager,
  customerSuccessEngineer,
  fromTo,
  fieldName,
  direction,
  orAnd
) => {
  return {
    filters: {
      featureAdoption: fa[0] ? fa : '*',
      logicOperator: orAnd === 'OR' ? 'or' : 'and',
      companyName: filterInput ? filterInput : '*',
      firstPaymentDate: periodFormat(date),
      plan: plan[0] ? plan : '*',
      billingCycle: billingCycle[0] ? billingCycle : '*',
      companySize: size[0] ? size : '*',
      country: country[0] ? country : '*',
      industry: industry[0] ? industry : '*',
      accountManager: accountManager[0] ? accountManager : '*',
      customerSuccessEngineer: customerSuccessEngineer[0]
        ? customerSuccessEngineer
        : '*',
      arr: {
        from: fromTo?.arrFrom ? fromTo.arrFrom : '*',
        to: fromTo?.arrTo ? fromTo.arrTo : '*'
      }
    },
    options: {
      sort: {
        fieldName: fieldName,
        direction: direction
      }
    }
  };
};

export const createFilterFa = (arrFrom = [], arrTo, t) => {
  arrFrom.map(item => {
    if (item !== 'null') {
      arrTo.push({
        value: item,
        label: featuresFormater(item, t)
      });
    }
    return '';
  });
};

export const createFilterFeatures = (futures = [], t) => {
  return futures.map(future => {
    return {
      label: {
        value: future.catName,
        label: featuresFormater(future.catName, t),
        openGroup: false
      },
      options: future.items.map(item => {
        return { value: item, label: featuresFormater(item, t) };
      })
    };
  });
};
